module.exports = __webpack_public_path__ + "img/undraw_walk_in_the_city_1ma6.9586ba0f.svg";